import React from 'react'
import { DragDropSectionProps } from './DragDropSection.types'
import styles from './DragDropSection.module.scss'
import cl from 'classnames'
import {
  DragDropContext,
  Droppable,
  DroppableProvided
} from 'react-beautiful-dnd'
import { DraggableSection } from './DraggableSection'

const DragDropSectionComponent = (props: DragDropSectionProps) => {
  const {
    className,
    style,
    draggableSections,
    onDragEnd,
    direction,
    droppableId = 'droppable'
  } = props

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable
        droppableId={droppableId}
        direction={direction}
      >
        {(provided: DroppableProvided) => {
          return (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              className={cl(styles.container, className)}
              style={style}
            >
              {draggableSections.map((section, index) => {
                return (
                  <DraggableSection
                    key={index}
                    index={index}
                    {...section}
                  />
                )
              })}
              {provided.placeholder}
            </div>
          )
        }}
      </Droppable>
    </DragDropContext>
  )
}

const DragDropSection = DragDropSectionComponent
export { DragDropSection }
